export default "__VITE_ASSET__CwkCeliO__"